var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCirclePlusSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#00BAC6"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.48 11.068v1.664h-4.628v4.628h-1.664v-4.628H6.56v-1.664h4.628V6.44h1.664v4.628h4.628Z",
  fill: "#fff"
})));
export { SvgCirclePlusSm as ReactComponent };
export default __webpack_public_path__ + "4b629f18b929bb57e112646a2267bed1.svg";